import React from "react";

import { NestedField } from "react-form";
import Checkbox from "components/form-fields/Checkbox";

const PermissionRows = ({ data }) => {
  return data.map(({ id, slug }) => {
    return (
      <tr key={id}>
        <td>
          <Checkbox field={slug} placeholder={slug} />
        </td>
        <td>{slug}</td>
      </tr>
    );
  });
};

export default function PermissionCheckLists({ permissions }) {
  if (permissions.loading) {
    return "loading...";
  }

  return (
    <div className="box">
      <h3>Permissions</h3>
      <NestedField field="permissions">
        <table className="table is-striped">
          <tbody>
            <PermissionRows data={permissions.data} />
          </tbody>
        </table>
      </NestedField>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Role/Form/PermissionCheckLists.js